export enum LoginStatusEnum {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  PENDING = "PENDING",
  IDLE = "IDLE",
}
